/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "key-a866706b--sprite",
  "use": "key-a866706b--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"key-a866706b--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(-361.609 -3217.674)\"><path d=\"M389.15,3234.343h-8.67a3.74,3.74,0,0,0-.12-.45c-.06-.18-.12-.36-.19-.53-.01-.01-.01-.01-.01-.02-.08-.18-.16-.35-.25-.52a6.046,6.046,0,0,0-2.43-2.43,5.712,5.712,0,0,0-.56-.27c-.01,0-.03-.01-.04-.01a4.647,4.647,0,0,0-.6-.2.9.9,0,0,0-.22-.06,5.677,5.677,0,0,0-1.44-.18,6.423,6.423,0,0,0-1.32.14c-.16.04-.31.08-.47.13-.13.04-.27.09-.4.14a6.1,6.1,0,0,0-2.88,2.38l.01.01a5.569,5.569,0,0,0-.77,1.87h-.03a5.917,5.917,0,0,0-.15,1.34,5.656,5.656,0,0,0,.15,1.31h.03a5.727,5.727,0,0,0,.77,1.86l-.02.02a5.76,5.76,0,0,0,1.86,1.88l.02-.02a5.944,5.944,0,0,0,1.88.78v.03a5.877,5.877,0,0,0,2.64,0v-.03a5.55,5.55,0,0,0,1.88-.78l.02.02a5.76,5.76,0,0,0,1.86-1.88l-.01-.01a5.49,5.49,0,0,0,.53-1.02c.05-.12.09-.24.13-.36.05-.16.09-.32.13-.49h5.69v1.32a1,1,0,0,0,1,1h.65a1,1,0,0,0,1-1v-1.32h.33a1,1,0,0,0,1-1v-.65A1,1,0,0,0,389.15,3234.343Zm-12.4,3.44a2.991,2.991,0,1,1,.89-2.13A2.991,2.991,0,0,1,376.75,3237.783Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
